import { render, staticRenderFns } from "./VTreeviewItem.vue?vue&type=template&id=2ea175c4&scoped=true&"
import script from "./VTreeviewItem.vue?vue&type=script&lang=js&"
export * from "./VTreeviewItem.vue?vue&type=script&lang=js&"
import style0 from "./VTreeviewItem.vue?vue&type=style&index=0&id=2ea175c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea175c4",
  null
  
)

export default component.exports